// extracted by mini-css-extract-plugin
export default {"inputMessage":"Message_inputMessage__BGJ0K","inputMessageError":"Message_inputMessageError__gnJnE","inputMessageSuccess":"Message_inputMessageSuccess__poMVz"};